import axios from 'axios';
import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getAllProductTasks = async () => (await requestFunnel.get('product-tasks')).data;

export const updateRating = async (productTaskId, rating, cancelExecutor = () => {}) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const requestOptions = getOptions();
  requestOptions.cancelToken = cancelToken;

  // Obtén el documento actual
  const currentData = (await requestFunnel.get(`product-tasks/${productTaskId}`, requestOptions)).data;
  const currentRating = currentData.rating;
  const { votesNumber } = currentData;

  // Calcula el nuevo promedio
  const newAverage = ((currentRating * votesNumber) + rating) / (votesNumber + 1);

  return (await requestFunnel.patch(`product-tasks/${productTaskId}/rating`, { rating: newAverage }, requestOptions)).data;
};
